import { render } from "./AddCategorieModal.vue?vue&type=template&id=8775561e&ts=true"
import script from "./AddCategorieModal.vue?vue&type=script&lang=ts"
export * from "./AddCategorieModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__